import AssistantIcon from '../assets/icons/Assistant.svg?react'
import ChatIcon from '../assets/icons/Chat.svg?react'
import GlobeIcon from '../assets/icons/Globe.svg?react'
import InboxIcon from '../assets/icons/Inbox.svg?react'
import LightbulbIcon from '../assets/icons/LightBulb.svg?react'
import MemoIcon from '../assets/icons/Memo.svg?react'
import MicrophoneIcon from '../assets/icons/MicrophoneRounded.svg?react'
import ShapesIcon from '../assets/icons/Shapes.svg?react'
import WandIcon from '../assets/icons/Wand.svg?react'

export const featuresList = [
    {
        key: 1,
        title: 'Ответы на любые вопросы',
        Icon: ChatIcon,
    },
    {
        key: 2,
        title: 'Ввод запросов голосом',
        Icon: MicrophoneIcon,
    },
    {
        key: 3,
        title: 'Помощь в учебе, работе и отдыхе',
        Icon: ShapesIcon,
    },
    {
        key: 4,
        title: 'Автовыбор модели для запросов',
        Icon: AssistantIcon,
    },
    {
        key: 5,
        title: 'Создание изображений, видео и аудио',
        Icon: WandIcon,
    },
    {
        key: 6,
        title: 'Поиск по всему Интернету',
        Icon: GlobeIcon,
    },
    {
        key: 7,
        title: 'Рассуждение и исследование',
        Icon: LightbulbIcon,
    },
    {
        key: 8,
        title: '«Мой диск» – хранение файлов',
        Icon: InboxIcon,
    },
    {
        key: 9,
        title: 'Расшифровка записей и встреч',
        Icon: MemoIcon,
    },
]
